import styled from "styled-components";

export const TeamPageWrapper = styled.div`
  padding-bottom: 25px;
`;
